module.exports = __webpack_public_path__ + "img/pragmatic.5e917cbb.png";